export const OPEN_WIDGET = 'GURU_WIDGET_OPEN'
export const CLOSE_WIDGET = 'GURU_WIDGET_CLOSE'
export const SET_VIEW = 'GURU_WIDGET_SET_VIEW'
export const ATTACH_ENTITY = 'GURU_WIDGET_ATTACH_ENTITY'
export const DETACH_ENTITY = 'GURU_WIDGET_DETACH_ENTITY'
export const OPEN_WITH_ENTITY = 'GURU_WIDGET_OPEN_WITH_ENTITY'
export const SET_PREFILLED_INPUT = 'GURU_WIDGET_SET_PREFILLED_INPUT'
export const SET_POSITION = 'GURU_WIDGET_SET_POSITION'
export const RESET_POSITION = 'GURU_WIDGET_RESET_POSITION'
export const SET_OVERRIDE_SCOPE = 'GURU_WIDGET_SET_OVERRIDE_SCOPE'
export const CLEAR_OVERRIDE_SCOPE = 'GURU_WIDGET_CLEAR_OVERRIDE_SCOPE'

export const openWidget = anchorContext => ({ type: OPEN_WIDGET, payload: { anchorContext } })

export const closeWidget = () => ({ type: CLOSE_WIDGET })

export const setView = view => ({ type: SET_VIEW, payload: { view } })

export const attachEntity = entityAttachment => ({ type: ATTACH_ENTITY, payload: { entityAttachment } })

export const detachEntity = () => ({ type: DETACH_ENTITY })

export const openWithEntity = ({ anchorContext, entityAttachment = null, initialView = 'chat', prefilledInput = '' }) => ({
  type: OPEN_WITH_ENTITY,
  payload: { anchorContext, entityAttachment, view: initialView, prefilledInput },
})

export const setPrefilledInput = prefilledInput => ({ type: SET_PREFILLED_INPUT, payload: { prefilledInput } })

export const setPosition = position => ({ type: SET_POSITION, payload: { position } })

export const resetPosition = () => ({ type: RESET_POSITION })

export const setOverrideScope = scope => ({
  type: SET_OVERRIDE_SCOPE,
  payload: { scope },
})

export const clearOverrideScope = () => ({ type: CLEAR_OVERRIDE_SCOPE })
